import { Colors } from '@oy/uicore';
import classNames from 'classnames';
import React, { isValidElement, ReactNode } from 'react';
import { formatString, makeId } from '../../../utilities/idComponent';
import { Text } from '../../Contents';
import styles from './Tab.module.css';

export type TabType = 'rounded' | 'bottomLine';

export type TabProps = {
  label: string | ReactNode;
  active?: boolean;
  activeType?: TabType;
  id?: string;
  onClick?: () => void;
};

const Tab = ({
  label,
  active = false,
  activeType = 'bottomLine',
  id = '',
  onClick,
}: TabProps) => {
  const isBottomLineType = activeType == 'bottomLine';
  const bottomLineTextColor = !active ? Colors.BLACK80 : Colors.BLUE100;

  const containerStyle = classNames({
    [styles.bottomLineContainer]: isBottomLineType,
  });

  const activeTabStyle = isBottomLineType
    ? classNames(styles.textContainer, { [styles.active]: active })
    : classNames(styles.tabContainer, active ? styles.tabContainerActive : '');

  const textStyle =
    isBottomLineType || active
      ? Text.Style.BodyMdSemibold
      : Text.Style.BodyMdRegular;

  const renderLabel = () => {
    if (isValidElement(label)) {
      return label;
    }
    return (
      <Text
        color={bottomLineTextColor}
        textStyle={textStyle}
        className={!isBottomLineType ? styles.text : ''}
        isColorInherit={!isBottomLineType}
      >
        {label}
      </Text>
    );
  };

  return (
    <div
      id={makeId('tab', formatString(label), id)}
      className={containerStyle}
      onClick={onClick}
    >
      <div className={activeTabStyle}>{renderLabel()}</div>
    </div>
  );
};

export default Tab;
